/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const e="esri-column",n={contentFull:`${e}__content--full`,sorter:`${e}__sorter`,headerContent:`${e}__header-content`,headerDescription:`${e}__header-description`,headerLabel:`${e}__header-label`,headerMenuIcon:`${e}__header-menu-icon`};export{n as css};
